import productCategoryMapper from './productCategoryMapper';

export default function priceListProductMapper({ product }) {
  return {
    ecommProductUuid: product.pricing.servicePricingUuid,
    ecommProductSku: product.service,
    ecommProductName: product.name,
    ecommProductCategory: productCategoryMapper({
      isPlan: product?.planContents?.length,
      serviceName: product.service
    }),
    ecommProductQuantity: 1,
    ecommProductPrice: product.pricing.price,
    productInterval: product.pricing.interval
  };
}
